import { connect } from 'react-redux';
import { loaderSet } from '../actions';
import { RootState } from '../store';

interface StateProps {
  loader: boolean;
}

interface DispatchProps {
  setLoader: (data: boolean) => void;
}

const mapStateToProps = (state: RootState): StateProps => ({
  loader: state.loader ?? false
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  setLoader: (data: boolean) => dispatch(loaderSet(data))
});

export default connect(mapStateToProps, mapDispatchToProps);
